module.exports = __webpack_public_path__ + "first-5_glossy_stripe.jpg?93d5db1e4ac4f779105ecc5e6972325f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_glossy_stripe.jpg
// module id = 582
// module chunks = 0